// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__ezPZa","productName":"Table_productName__3IUoE"};